import api from "./api";
import API_ROUTES from "./apiRoutes";

export const getSocietyAdmins = async () => {
  try {
    const res = await api.get(API_ROUTES.societyAdmins.list);
    return res.data;
  } catch (err) {
    console.error("GET SOCIETY ADMINS ERROR:", err);
    throw err;
  }
};

export const createSocietyAdmin = async (data) => {
  try {
    const res = await api.post(API_ROUTES.societyAdmins.list, data);
    return res.data;
  } catch (err) {
    console.error("CREATE SOCIETY ADMIN ERROR:", err);
    throw err;
  }
};

export const updateSocietyAdmin = async (id, data) => {
  try {
    const res = await api.put(API_ROUTES.societyAdmins.details(id), data);
    return res.data;
  } catch (err) {
    console.error("UPDATE SOCIETY ADMIN ERROR:", err);
    throw err;
  }
};

export const deleteSocietyAdmin = async (id) => {
  try {
    const res = await api.delete(API_ROUTES.societyAdmins.details(id));
    return res.data;
  } catch (err) {
    console.error("DELETE SOCIETY ADMIN ERROR:", err);
    throw err;
  }
};
